import { Card, Divider, Pagination, Modal, Input, Select, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
// import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../methods/redux/hooks';

import remakeQueryString from '../../methods/utils/remake-query-string';
import {
	createProxyInvestment,
	startProxyInvestment,
	unregisteredInvestmentItems,
} from '../../methods/redux/reducers/investment';
import { getCurrencies } from '../../methods/redux/reducers/currency';
import UnregisteredInvestmentList from './UnregisteredInvestmentLists';
import NativeNumber from '../../component/Numeral';

const Style = styled.div`
	& .mini-report {
		& > * {
			display: inline-block;
			margin-right: 10px;
			margin-bottom: 10px;
		}
		& .amount {
			font-weight: 600;
			font-size: 16px;

			&.red {
				color: var(--red-color);
			}
		}
	}

	& .out-links {
		display: inline-block;
		margin-right: 20px;
		text-decoration: underline;
	}
`;

const InvestmentUnregisteredUsers = () => {
	const [visible, setVisible] = useState(false);
	const [visibleCreateInvestment, setVisibleCreateInvestment] = useState(false);
	const dispatch = useAppDispatch();
	const [searchParams, setSearchParams] = useSearchParams();
	const { unregisteredInvestments } = useAppSelector(
		(store) => store.investment
	);
	const { currencies } = useAppSelector((store) => store.currencies);
	// const { user } = useAppSelector((store) => store.userProfile);
	const [state, setState] = useState({
		bvn: '',
		memberId: '',
	});
	const [createState, setCreateState] = useState({
		investmentForm: '',
		memberId: '',
		durationInMonth: '',
		title: '',
		reInvestAfterMaturity: false,
		amount: 0,
		currencyId: '',
	});

	const submit = () => {
		dispatch(startProxyInvestment({ ...state }));
		setVisible(false);
	};

	const submitCreateInvestment = () => {
		dispatch(createProxyInvestment({ ...createState }));
		setVisibleCreateInvestment(false);
	};

	const investForm = [
		{
			key: 'REAL_ESTATE',
			label: 'REAL_ESTATE',
		},
		{
			key: 'STOCK',
			label: 'STOCK',
		},
	];

	const reInvest = [
		{
			key: 'true',
			label: 'true',
		},
		{
			key: 'false',
			label: 'false',
		},
	];

	const duration = [
		{
			key: 3,
			label: 3,
		},
		{
			key: 6,
			label: 6,
		},
		{
			key: 12,
			label: 12,
		},
	];

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length === 0) {
			setSearchParams({
				pageId: '1',
				perPage: String(unregisteredInvestments.paginator.perPage),
			});
		}

		dispatch(unregisteredInvestmentItems({ ...queryData }));
		dispatch(getCurrencies({}));
	}, []);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};
	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			dispatch(unregisteredInvestmentItems({ ...queryData }));
		}
	}, [searchParams]);

	return (
		<Style>
			<Card>
				<h1>
					Unregistered Investment Users{' '}
					{/* {user.profile?._id && (
						<span>
							for{' '}
							<Link to={`/user-profile/${user.profile?._id}`}>
								@{user.profile?.username}
							</Link>
						</span>
					)} */}
				</h1>
				<p>
					List of investment users whose registration on third party is not
					completed yet{' '}
				</p>
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
					}}
				>
					{/* <div style={{ marginRight: '10px' }}>
						<Button
							disabled={isStartInvestment}
							type="primary"
							onClick={() => setVisible(true)}
						>
							Start Investment
						</Button>
					</div> */}

					{/* <div>
						<Button
							disabled={!isStartInvestment}
							type="primary"
							onClick={() => setVisibleCreateInvestment(true)}
						>
							Create Investment
						</Button>
					</div> */}
				</div>

				<Divider />

				<div className="mini-report">
					<Tag
						color="red"
						style={{
							padding: '7px 15px',
							marginRight: '10px',
							marginBottom: '10px',
						}}
					>
						<p>Unregistered Users</p>
						<p>
							<NativeNumber
								value={unregisteredInvestments.paginator.itemCount}
							/>
						</p>
					</Tag>
				</div>

				<br />

				<Divider />

				<br />

				<p>
					Total of{' '}
					<strong>{unregisteredInvestments.paginator.itemCount} items</strong>{' '}
					found
				</p>
				<Divider />

				<div>
					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={unregisteredInvestments?.paginator?.itemCount}
						current={unregisteredInvestments?.paginator?.currentPage}
						pageSize={unregisteredInvestments?.paginator?.perPage ?? 20}
					/>
				</div>

				<br />

				{unregisteredInvestments &&
					unregisteredInvestments.itemsList.map((index: any) => (
						<UnregisteredInvestmentList
							key={index._id}
							investmentProfile={index}
						/>
					))}

				<br />

				<Pagination
					onChange={(pageId) => updateQueryString({ pageId })}
					total={unregisteredInvestments?.paginator?.itemCount}
					current={unregisteredInvestments?.paginator?.currentPage}
					pageSize={unregisteredInvestments?.paginator?.perPage ?? 20}
					showSizeChanger
					showQuickJumper
				/>
			</Card>
			<Modal
				okText="Start Investment"
				title="Start Investment"
				onOk={submit}
				visible={visible}
				onCancel={() => setVisible(false)}
			>
				<p>Bvn Number</p>
				<Input
					value={state.bvn}
					onChange={(e) => setState({ ...state, bvn: e.target.value })}
				/>
			</Modal>

			<Modal
				okText="Create Investment"
				title="Create Investment"
				onOk={submitCreateInvestment}
				visible={visibleCreateInvestment}
				onCancel={() => setVisibleCreateInvestment(false)}
			>
				<p>Title</p>
				<Input
					value={createState.title}
					onChange={(e) =>
						setCreateState({ ...createState, title: e.target.value })
					}
				/>
				<p>Amount</p>
				<Input
					value={createState.amount}
					onChange={(e) =>
						setCreateState({ ...createState, amount: Number(e.target.value) })
					}
				/>
				<p>Investment Form</p>
				<Select
					defaultValue={createState.investmentForm}
					style={{ width: '100%' }}
					onChange={(value) =>
						setCreateState({ ...createState, investmentForm: value })
					}
				>
					{investForm.map((i: any) => (
						<Select.Option key={i.key} value={i.key}>
							{i.label}
						</Select.Option>
					))}
				</Select>

				<p>Duration In Month</p>
				<Select
					defaultValue={createState.durationInMonth}
					style={{ width: '100%' }}
					onChange={(value) =>
						setCreateState({ ...createState, durationInMonth: value })
					}
				>
					{duration.map((i: any) => (
						<Select.Option key={i.key} value={i.key}>
							{i.label}
						</Select.Option>
					))}
				</Select>

				<p>ReInvest After Maturity</p>
				<Select
					defaultValue={createState.reInvestAfterMaturity}
					style={{ width: '100%' }}
					onChange={(value) =>
						setCreateState({
							...createState,
							reInvestAfterMaturity: Boolean(value),
						})
					}
				>
					{reInvest.map((i: any) => (
						<Select.Option key={i.key} value={i.key}>
							{i.label}
						</Select.Option>
					))}
				</Select>

				<p>Currency</p>
				<Select
					defaultValue={createState.currencyId}
					style={{ width: '100%' }}
					onChange={(value) =>
						setCreateState({ ...createState, currencyId: value })
					}
				>
					{currencies
						.filter((i: any) => i.useInvestment)
						.map((i: any) => (
							<Select.Option key={i._id} value={i._id}>
								{i.symbol}
							</Select.Option>
						))}
				</Select>
			</Modal>
		</Style>
	);
};

export default InvestmentUnregisteredUsers;
